import { InvalidPage } from 'assessment/pages/components';
import { lazy } from 'react';
import { Route, Switch } from 'react-router-dom';

const PublicAssessment = lazy(() =>
  import(/* webpackChunkName: "PublicAssessment"*/ '../pages/')
);

const routes = [
  { route: '/:accountId/:assessmentId', component: PublicAssessment },
];

export const AssessmentRoutes = () => {
  return (
    <Switch>
      {routes.map((item, idx) => {
        const Component = item.component;
        return (
          <Route key={idx} path={item.route}>
            <Component />
          </Route>
        );
      })}
      <Route path="*">
        <InvalidPage />
      </Route>
    </Switch>
  );
};
